export default {
  // Navigation
  nav_home: 'Início',
  nav_shopping_guide: 'Guia de Compras',
  nav_categories: 'Categorias',
  nav_guides: 'Guias',
  nav_reviews: 'Avaliações',
  nav_shipping: 'Envio',
  nav_qc: 'QC',
  nav_safety: 'Segurança',
  nav_faq: 'FAQ',
  nav_contact: 'Contato',
  nav_language: 'Idioma',

  // Hero
  hero_eyebrow: 'GUIA INDEPENDENTE',
  hero_title: 'CSSBuy Spreadsheet: encontre, compare e pesquise produtos com mais facilidade',
  hero_subtitle: 'Explore um recurso independente sobre CSSBuy Spreadsheet, com guias de produtos, QC, custos de envio, armazém, avaliações e dicas práticas para comprar com mais segurança.',
  cta_explore: 'Explorar CSSBuy Spreadsheet',
  cta_guide: 'Ver Guia CSSBuy',
  cta_main_site: 'Ir para o Site Principal',
  cta_buy_now: 'Comprar Agora',
  cta_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',

  // Categories
  categories_title: 'Explore as Categorias de Produtos',
  categories_subtitle: 'Navegue por categoria e encontre o que precisa através do nosso hub de recursos organizado.',
  categories_all: 'Todas as Categorias',
  category_shoes: 'Sapatos',
  category_hoodies: 'Moletons/Suéteres',
  category_tshirts: 'Camisetas',
  category_jackets: 'Jaquetas',
  category_pants: 'Calças/Shorts',
  category_headwear: 'Chapéus/Bonés',
  category_sets: 'Conjuntos',
  category_underwear: 'Roupa Íntima',
  category_jersey: 'Jersey',
  category_accessories: 'Acessórios',
  category_bags: 'Bolsas',
  category_belts: 'Cintos',
  category_perfumes: 'Perfumes',
  category_other: 'Outros Itens',

  // What is CSSBuy Spreadsheet
  what_is_title: 'O que é o CSSBuy Spreadsheet?',
  what_is_text: 'O CSSBuy Spreadsheet é uma forma prática de organizar e pesquisar produtos, categorias, informações de vendedores e referências de compra. Reunimos guias independentes para ajudar você a entender produtos, QC, envio, armazém e outros aspectos importantes antes de realizar uma compra.',

  // Value props
  value_title: 'Tudo o que você precisa saber antes de comprar',
  value_spreadsheet: 'Encontre e organize informações de produtos.',
  value_qc: 'Aprenda como analisar fotos e detalhes antes do envio.',
  value_shipping: 'Entenda custos, métodos e fatores que influenciam o envio.',
  value_warehouse: 'Entenda armazenamento, inspeção e consolidação.',
  value_review: 'Consulte análises e informações independentes.',
  value_safety: 'Aprenda a identificar links suspeitos, golpes e contas falsas.',

  // How it works
  how_title: 'Como usar o CSSBuy Spreadsheet',
  how_step1: 'Pesquise um produto ou categoria.',
  how_step2: 'Compare as informações.',
  how_step3: 'Verifique vendedor e detalhes.',
  how_step4: 'Consulte QC.',
  how_step5: 'Analise custos e métodos de envio.',
  how_step6: 'Confirme informações atuais.',
  how_step7: 'Se desejar, continue para o site principal.',
  how_cta: 'Começar a Pesquisar',

  // Articles
  articles_title: 'Guias e Artigos Populares',
  articles_subtitle: 'Recursos aprofundados para ajudar você a tomar decisões informadas.',
  article_spreadsheet_guide: 'Guia Completo do CSSBuy Spreadsheet',
  article_spreadsheet_guide_desc: 'Um guia abrangente para entender e usar o CSSBuy Spreadsheet de forma eficaz.',
  article_review: 'Avaliação CSSBuy 2026',
  article_review_desc: 'Avaliação independente cobrindo envio, QC, custos, armazém e segurança.',
  article_shipping: 'Guia de Custos de Envio CSSBuy',
  article_shipping_desc: 'Entenda custos de envio, métodos, cálculos de peso e prazos de entrega.',
  article_qc: 'Guia de QC CSSBuy',
  article_qc_desc: 'Aprenda a ler fotos de QC, verificar medidas e confirmar detalhes do produto.',
  article_warehouse: 'Guia do Armazém CSSBuy',
  article_warehouse_desc: 'Entenda armazenamento, inspeção, consolidação e taxas do armazém.',
  article_coupon: 'Cupom e Código de Desconto CSSBuy',
  article_coupon_desc: 'Como funcionam cupons e códigos de desconto e como verificá-los com segurança.',
  article_legit: 'O CSSBuy é Legítimo?',
  article_legit_desc: 'Uma análise honesta sobre a legitimidade, segurança e o que esperar do CSSBuy.',
  article_beginners: 'CSSBuy Spreadsheet para Iniciantes',
  article_beginners_desc: 'Um guia simples para quem está começando com o CSSBuy Spreadsheet.',
  article_buying: 'Guia de Compras CSSBuy',
  article_buying_desc: 'Orientação passo a passo para uma compra segura e informada.',
  article_methods: 'Métodos de Envio CSSBuy',
  article_methods_desc: 'Compare métodos de envio, velocidades e fatores de custo.',
  article_qc_checklist: 'Checklist de QC CSSBuy',
  article_qc_checklist_desc: 'Um checklist prático para revisar fotos e detalhes de QC.',
  article_seller: 'Guia de Vendedores CSSBuy',
  article_seller_desc: 'Como verificar vendedores e identificar fontes confiáveis.',
  article_safety_guide: 'Guia de Segurança CSSBuy',
  article_safety_guide_desc: 'Práticas essenciais de segurança para proteger sua conta e seu dinheiro.',
  article_faq_guide: 'FAQ do CSSBuy Spreadsheet',
  article_faq_guide_desc: 'Respostas para as perguntas mais comuns sobre CSSBuy Spreadsheet.',
  read_article: 'Ler Artigo',

  // Shipping
  shipping_title: 'CSSBuy Shipping Cost: entenda os principais custos',
  shipping_text: 'O custo final pode variar de acordo com destino, peso, volume, método de transporte, seguro, embalagem e outros fatores. Consulte sempre os valores atuais antes de confirmar o pedido.',
  shipping_cta: 'Ver Guia de Envio',

  // Safety
  safety_title: 'Compre e pesquise com mais segurança',
  safety_text: 'Verifique fontes, vendedores, links e informações antes de comprar. Nunca compartilhe senhas, códigos de autenticação ou informações financeiras com contas não verificadas.',
  safety_cta: 'Visitar Centro de Segurança',

  // FAQ
  faq_title: 'Perguntas frequentes sobre CSSBuy Spreadsheet',
  faq_q1: 'O que é CSSBuy Spreadsheet?',
  faq_a1: 'CSSBuy Spreadsheet é um recurso organizado que ajuda usuários a pesquisar produtos, categorias, vendedores e informações de compra antes de comprar através do CSSBuy.',
  faq_q2: 'Como usar o CSSBuy Spreadsheet?',
  faq_a2: 'Comece pesquisando um produto ou categoria, compare informações, verifique detalhes do vendedor, confira fotos de QC e entenda custos de envio antes de prosseguir.',
  faq_q3: 'CSSBuy é legítimo?',
  faq_a3: 'CSSBuy é um serviço de agente de compras conhecido. Este site fornece guias e recursos independentes para ajudar usuários a tomar decisões informadas.',
  faq_q4: 'CSSBuy é seguro?',
  faq_a4: 'A segurança depende de seguir as melhores práticas: verificar vendedores, checar QC, entender envio e nunca compartilhar informações sensíveis.',
  faq_q5: 'Quanto custa o envio?',
  faq_a5: 'Os custos de envio variam por destino, peso, volume, método e outros fatores. Sempre verifique as tarifas atuais antes de pedir.',
  faq_q6: 'Como funciona o armazém?',
  faq_a6: 'O armazém guarda seus itens, realiza inspeções, tira fotos de QC e consolida pacotes antes de enviar.',
  faq_q7: 'O que significa QC?',
  faq_a7: 'QC significa Controle de Qualidade. Envolve verificar fotos do produto, medidas e detalhes antes do item ser enviado para você.',
  faq_q8: 'Como verificar um vendedor?',
  faq_a8: 'Verifique avaliações, reviews, histórico de transações e confirme detalhes do produto através de múltiplas fontes antes de comprar.',
  faq_cta: 'Ver todas as perguntas',

  // Final CTA
  final_cta_title: 'Pronto para começar sua pesquisa?',
  final_cta_text: 'Explore o CSSBuy Spreadsheet, compare informações e consulte nossos guias antes de tomar sua decisão.',
  final_cta_explore: 'Explorar CSSBuy Spreadsheet',
  final_cta_main: 'Continuar para o Site Principal',

  // Footer
  footer_tagline: 'Hub Independente de Recursos CSSBuy Spreadsheet',
  footer_resources: 'Recursos',
  footer_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',
  footer_cssbuy_review: 'CSSBuy Review',
  footer_cssbuy_shipping: 'CSSBuy Shipping',
  footer_cssbuy_shipping_cost: 'CSSBuy Shipping Cost',
  footer_cssbuy_qc: 'CSSBuy QC',
  footer_cssbuy_warehouse: 'CSSBuy Warehouse',
  footer_cssbuy_coupon: 'CSSBuy Coupon',
  footer_cssbuy_discount: 'CSSBuy Discount Code',
  footer_cssbuy_legit: 'CSSBuy Legit',
  footer_cssbuy_safety: 'CSSBuy Safety',
  footer_guides: 'Guias',
  footer_comparisons: 'Comparações',
  footer_faq: 'FAQ',
  footer_legal: 'Legal',
  footer_privacy: 'Privacidade',
  footer_terms: 'Termos',
  footer_disclaimer: 'Aviso Legal',
  footer_contact: 'Contato',
  footer_languages: 'Idiomas',
  footer_english: 'Inglês',
  footer_portuguese: 'Português (BR)',
  footer_german: 'Alemão',
  footer_copyright: 'cssbuybr.help é um recurso independente. Não afiliado ao CSSBuy.',

  // Trust strip
  trust_independent: 'Guias Independentes',
  trust_organized: 'Informação Organizada',
  trust_updated: 'Atualizado Regularmente',

  // Meta
  meta_title: 'CSSBuy Spreadsheet: Guias, Produtos, QC e Envio',
  meta_description: 'Explore um guia independente sobre CSSBuy Spreadsheet, produtos, QC, custos de envio, armazém e dicas práticas de compra.',
};